import { IModuleToggles } from "@/Store";

export const moduleForPath = (path: string): keyof IModuleToggles | null => {
  if (path.startsWith("/usuarios")) return "users";
  if (path.startsWith("/departamentos")) return "departments";
  if (path.startsWith("/leads")) return "leads";
  if (path.startsWith("/clientes")) return "clients";
  if (path.startsWith("/contatos")) return "contacts";
  if (path.startsWith("/projetos")) return "projects";
  if (path.startsWith("/assinantes")) return "subscriptions";
  if (
    path.startsWith("/financeiro") ||
    path.startsWith("/faturas") ||
    path.startsWith("/contratos-cobranca")
  )
    return "finance";
  if (path.startsWith("/documentos")) return "documents";
  if (path.startsWith("/kanban")) return "kanban";
  if (path.startsWith("/funcionarios")) return "employees";
  if (
    path.startsWith("/jornadas") ||
    path.startsWith("/feriados") ||
    path.startsWith("/terminais") ||
    path.startsWith("/terminal-publico") ||
    path.startsWith("/meu-ponto") ||
    path.startsWith("/ponto")
  )
    return "timeclock";
  return null;
};

export const canAccessModuleRoute = ({
  module,
  userType,
  userModules,
  companyModules,
}: {
  module: keyof IModuleToggles | null;
  userType?: string;
  userModules: string[];
  companyModules?: Partial<IModuleToggles>;
}): boolean => {
  if (!module) return true;
  if (companyModules?.[module] === false) return false;
  if (["superadmin", "owner", "admin", "support"].includes(userType ?? ""))
    return true;
  return userType === "member" && userModules.includes(module);
};

const SETTINGS_ROLES = ["superadmin", "owner", "admin"];

export const canAccessSettings = (userType?: string): boolean =>
  SETTINGS_ROLES.includes(userType ?? "");
